import { matchPath } from "react-router-dom";
import type { PushPathOptions } from "feat/globalRouter/performPush";
import { routes } from "routing";
import { bs } from "state/bound.store";

/**
 * Item detail routes reached from a member's itinerary. They have no `:userId` of their own,
 * so pushes to them carry the viewed user id in navigation state; `useViewedUserId` reads it
 * back.
 */
const CARRIES_VIEWED_USER: string[] = [
  routes.item.flight.path,
  routes.item.activity.path,
  routes.item.hotel.path,
  routes.item.hireCar.path,
  routes.item.transport.path,
  routes.item.parking.path,
];

/** Adds the viewed user to a push's navigation state, for the routes that read it back. */
export function withViewedUser(
  path: string,
  options: PushPathOptions | undefined,
  viewedUserId: number | null,
): PushPathOptions | undefined {
  if (viewedUserId === null) return options;
  if (!CARRIES_VIEWED_USER.some((pattern) => matchPath(pattern, path))) return options;
  return { ...options, state: { ...(options?.state ?? {}), viewedUserId } };
}

/**
 * The member page must not open for the acting user themselves: a member page for yourself
 * offers a chat with yourself. `getCurrentUser` rather than `wpUser`, so a guest browsing as
 * the user it follows counts as that user.
 */
export function blocksSelfNavigation(path: string): boolean {
  const match = matchPath(routes.team.member.path, path);
  if (!match) return false;
  const currentUserId = bs().getCurrentUser()?.id;
  return currentUserId !== undefined && match.params.userId === String(currentUserId);
}
